export enum ConfirmPanelType {
  ERROR,
  SUCCESS,
}
